import { dloInfoPos } from "@/utils/pos";
import _ from "lodash";


export default {
  methods: {
    async getPosDloInfo(dloInfoData, feeShip) {
      const DELIVERY_INFO = dloInfoData.furtherInstructions.find((e) => e.key == "DELIVERY_INFO");
      const DELIVERY_INFO_DATA = DELIVERY_INFO.params;
      const posDloInfo = {
        ..._.cloneDeep(dloInfoPos),
        shippingAddress: {
          address: DELIVERY_INFO_DATA.shippingAddress,
          city: DELIVERY_INFO_DATA.shippingCity,
          cityName: DELIVERY_INFO_DATA.shippingCityName,
          district: DELIVERY_INFO_DATA.shippingDistrict,
          districtName: DELIVERY_INFO_DATA.shippingDistrictName,
          village: DELIVERY_INFO_DATA.shippingVillage,
          villageName: DELIVERY_INFO_DATA.shippingVillageName,
          lat: DELIVERY_INFO_DATA.pickUpLat,
          lng: DELIVERY_INFO_DATA.pickUpLng,
          phoneNo: DELIVERY_INFO_DATA.receiverPhoneNo,
          receiverId: dloInfoData.partyB.resId,
          receiverName: DELIVERY_INFO_DATA.receiverName,
        },
        shipperInfo: {
          id: dloInfoData.partyOther.resId,
          name: dloInfoData.partyOther.displayName,
          phoneNo: dloInfoData.partyOther.phoneNo,
          text: `${dloInfoData.partyOther.displayName} - ${dloInfoData.partyOther.phoneNo}`,
        },
        shippingFee: +dloInfoData.lineItemFinalizing.finalAmount / 1000, // fee DOI TAC GIAO HANG
        addFeesShipping: {
          amount: +feeShip, // FEE SHIP BAO KHACH
          cat: "SHIPPING_FEE",
          key: "SHIPPING_FEE",
          name: "Phí ship báo khách",
        },
        targetService: dloInfoData.targetService,
        note: dloInfoData.note,
        packageInfo: {
          heightInCentimeter: +DELIVERY_INFO_DATA.packageHeight,
          lengthInCentimeter: +DELIVERY_INFO_DATA.packageLength,
          weightInKilo: +DELIVERY_INFO_DATA.packageWeight,
          widthInCentimeter: +DELIVERY_INFO_DATA.packageWidth,
        },
        // listPartnerDilivery: [],
        // listPackagesDilivery: [],
        cod: DELIVERY_INFO_DATA.cod ? +DELIVERY_INFO_DATA.cod/1000 : 0,
        // deliveryServicePack: {
        //   packageInfo: {
        //     id: null,
        //     name: null,
        //   },
        //   partnerCode: null,
        // },
        // appCode: null,
        // appPackage: null
      };
      if (dloInfoData.targetService == "DELIVERY_PARTNER") {
        posDloInfo.shipperInfo = {
          ...posDloInfo.shipperInfo,
          id: null,
          name: null,
          phoneNo: null,
          text: null,
        }
      }

      return posDloInfo;
    },
    
    convertDataFromDLOform(dloInfo) {
      dloInfo.cod = dloInfo.cod ? this.checkNumReplaceComma(dloInfo.cod)*1000 : null
      dloInfo.shippingFee = this.checkNumReplaceComma(dloInfo.shippingFee)*1000
      dloInfo.packageInfo.heightInCentimeter = +dloInfo.packageInfo.heightInCentimeter
      dloInfo.packageInfo.lengthInCentimeter = +dloInfo.packageInfo.lengthInCentimeter
      dloInfo.packageInfo.weightInKilo = +dloInfo.packageInfo.weightInKilo
      dloInfo.packageInfo.widthInCentimeter = +dloInfo.packageInfo.widthInCentimeter
      delete dloInfo.shipperInfo.text

      return dloInfo
    },

  }
}